/**
 * Geteilte Positions-Klemmung schwebender Panels über der Partitur (`BassLyricPopover`).
 * Beide schweben als absolutes Overlay im Body-Container und werden auf die Koordinaten der
 * angeklickten Note (`selectedNoteX/Y` aus dem `ScoreEditContext`) ausgerichtet.
 */

/** Mindestabstand zum Rand des Containers (px). */
export const PANEL_MARGIN = 8;

/** Auf `center` zentrierte, in `[PANEL_MARGIN, extent - size - PANEL_MARGIN]` geklemmte
 *  Startposition; ohne Anker (`center === null`) der `fallback`. */
export function clampedPosition(center: number | null, size: number, extent: number, fallback: number): number {
    if (null === center) return fallback;
    const maxStart = Math.max(PANEL_MARGIN, extent - size - PANEL_MARGIN);
    return Math.min(Math.max(PANEL_MARGIN, center - size / 2), maxStart);
}
